<template>    
    <div class="container">
      <VUEConfirm :Popup="PopupEliminaMessaggio" :Richiesta="DescrPopupEliminaMessaggio" :PathLogo="require('@/assets/images/LogoDMS.png')" :Programma="'DMSEW'" @OnClickConfermaPopup="ConfermaElimina" @OnClickChiudiPopup="AnnullaElimina">
      </VUEConfirm>
        <div class="row"> 
                                
                <div class="block">
                    <div class="header" style="padding:0px">
                      <div class="block block-transparent nm">
                          <div class="content controls">
                              <div class="form-row">
                                  <div class="col-md-2" style="float:right;padding-right:0px;">
                                      <button type="button" class="btn btn-success" @click="OnClickAggiungiMessaggio" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
                                  </div>                            
                              </div>
                          </div>
                      </div>                                       
                    </div>
                    <div class="content">

                        <table cellpadding="0" cellspacing="0" width="100%" class="table table-bordered table-striped sortable">
                            <thead style="background-color:#60604d;color:white">
                                <tr>
                                    <th width="20%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneMessaggi','TKN_GEST_MESSAGGI_TITOLO',this.LinguaUtente) }}</th>
                                    <th width="52%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneMessaggi','TKN_GEST_MESSAGGI_TXT_MSG',this.LinguaUtente) }}</th>
                                    <th width="20%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneMessaggi','TKN_GEST_MESSAGGI_ALLEGATI',this.LinguaUtente) }}</th>
                                    <th width="5%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneMessaggi','TKN_GEST_MESSAGGI_AZIONI',this.LinguaUtente) }}</th>
                                </tr>
                            </thead>
                            <tbody :style="{'background-color' : Arancione}">
                                <tr v-for="Messaggio, index in ListaMessaggi" :Key="Messaggio.Chiave">
                                    <td>
                                        <img v-if="Messaggio.Immagine"
                                        :src="Messaggio.Immagine"
                                         style="width:40px; height:40px; margin-right:8px;border:1px solid rgba(255,255,255,0.3); border-radius:0" 
                                         class="img-circle img-thumbnail"/>

                                         <img v-else src="@/assets/images/IconaPDF.png"
                                         style="width:40px; height:40px; margin-right:8px;background:white;border:1px solid rgba(255,255,255,0.3); border-radius:0" 
                                         class="img-circle img-thumbnail"/>
                                         
                                         {{Messaggio.Titolo}} 
                                    </td>
                                    <td style="vertical-align:middle">{{Messaggio.Testo}}</td>
                                    <td v-if="Messaggio.Allegati.length > 0" style="vertical-align:middle">
                                        <tr v-for="Allegato in ListaMessaggi[index].Allegati" :Key="Allegato.Chiave">{{ Allegato.NomeFile }}</tr>
                                    </td>
                                    <td v-else style="vertical-align:middle">{{ this.GetTraduzioneLabel('VUEAppContentGestioneMessaggi','TKN_GEST_MESSAGGI_NO_ALLEGATO',this.LinguaUtente) }}</td>
                                    <td style="vertical-align:middle;text-align:center;">
                                        <div>
                                            <i class="fa fa-pencil text-warning ZMIconButton" @click="OnClickModificaMessaggio(Messaggio)" style="margin-right:20px"></i>
                                            <i class="fa fa-trash-o text-danger ZMIconButton" @click="OnClickEliminaMessaggio(Messaggio)"></i>
                                        </div>
                                    </td>                                    
                                </tr>
                            </tbody>
                        </table>
                        
                    </div>
                </div>          
            </div> 
    </div>           
</template>


<script>
import { SFONDO, SystemInformation} from '@/SystemInformation.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import VUEConfirm from '@/utils/VUEConfirm.vue';

export default {
    name:'app',
    components: {
                   VUEConfirm
    },
    mixins: [ MixInsGestioneTraduzioni ],
    data()
    {
       return {
                ListaMessaggi                    : [],
                PopupEliminaMessaggio            : false,
                MessaggioPopup                   : {},
                DescrPopupEliminaMessaggio       : '',
                Arancione                        : SFONDO.Arancione,
                LinguaUtente                     : SystemInformation.UserInformation.Lingua
              }
    },
    methods :
    {
      OnClickAggiungiMessaggio()
      {
        this.$router.push('/Messaggio/nuovo')
      },

      CaricaListaMessaggi()
      {
        var Self = this;
        SystemInformation.AdvQuery.GetSQL('Admin_Messaggi',{},
                                            function(Results)
                                            {
                                                let ArrayInfoMessaggi = SystemInformation.AdvQuery.FindResults(Results,"ListaMessaggi")
                                                let ArrayInfoAllegati = SystemInformation.AdvQuery.FindResults(Results,"ListaAllegati")
                                                if (ArrayInfoMessaggi != undefined)
                                                {
                                                    for (let i = 0; i < ArrayInfoMessaggi.length; i++)
                                                    {
                                                        let ObjMessaggio = {Chiave   : ArrayInfoMessaggi[i].CHIAVE,
                                                                            Titolo   : ArrayInfoMessaggi[i].TITOLO,
                                                                            Immagine : ArrayInfoMessaggi[i].IMMAGINE,
                                                                            Testo    : ArrayInfoMessaggi[i].TESTO,
                                                                            Allegati : []}
                                                        if (ArrayInfoAllegati != undefined)
                                                        {
                                                            for (let j = 0; j < ArrayInfoAllegati.length; j++)
                                                            {
                                                                if (ArrayInfoAllegati[j].ID_MESSAGGIO == ObjMessaggio.Chiave)
                                                                    ObjMessaggio.Allegati.push({
                                                                                                  Chiave : ArrayInfoAllegati[j].CHIAVE,
                                                                                                  Allegato : ArrayInfoAllegati[j].ALLEGATO,
                                                                                                  Tipo : ArrayInfoAllegati[j].TIPO,
                                                                                                  NomeFile : ArrayInfoAllegati[j].NOME_FILE
                                                                    })
                                                            }
                                                        }
                                                        Self.ListaMessaggi.push(ObjMessaggio)
                                                    }
                                                }
                                                else SystemInformation.HandleError('Errore nel modello messaggi'); 
                                                
                                            },
                                            SystemInformation.HandleError)
      },

      ConfermaElimina()
      {
         let messaggio = this.MessaggioPopup
         var ObjQuery = { Operazioni: [] };
         var Self = this;
            ObjQuery.Operazioni.push({
                                            Query: "DeleteAllegati",
                                            Parametri: {
                                                        Chiave              : messaggio.Chiave
                                                    }
                                        });
            ObjQuery.Operazioni.push({
                                            Query: "DeleteLetti",
                                            Parametri: {
                                                        Chiave              : messaggio.Chiave
                                                    }
                                        });
            ObjQuery.Operazioni.push({
                                        Query: "DeleteMessaggio",
                                        Parametri: {
                                                    Chiave              : messaggio.Chiave
                                                }
                                    });
            SystemInformation.AdvQuery.PostSQL('Admin_Messaggi',ObjQuery,
                                                function()
                                                { 
                                                    Self.$router.go()
                                                },
                                                SystemInformation.HandleError)
         this.AnnullaElimina()
      },
      AnnullaElimina()
      {
         this.PopupEliminaMessaggio = false
      },

      OnClickModificaMessaggio(messaggio)
      {
        this.$router.push('/Messaggio/' + messaggio.Chiave)
      },

      OnClickEliminaMessaggio(messaggio)
      {
        this.PopupEliminaMessaggio = true
        this.MessaggioPopup = messaggio
        this.DescrPopupEliminaMessaggio = this.GetTraduzioneLabel('VUEAppContentGestioneMessaggi','TKN_GEST_MESSAGGI_ELIMINARE',this.LinguaUtente) + ' ' + messaggio.Titolo + '?'        
      }
    },
    computed :
    {
        
    },
    beforeMount()
    {
       this.CaricaListaMessaggi()
    }
}
</script>